import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'components/Modal';
import Button from 'components/Button';
import TextField from 'components/TextField';
import { actions as toastrActions } from 'react-redux-toastr';
import ModalBuscaMunicipio from './components/ModalBuscaMunicipio';
import { Container, WrapperButtons, WrapperInput, Row, InputWithButton } from './styles';

function ModalEncerramentoMdfe({ open, onClose, onConfirm, quantidadeMdfe = 0 }) {
  const dispatch = useDispatch();
  const [dataEncerramento, setDataEncerramento] = useState('');
  const [uf, setUf] = useState('');
  const [codigoMunicipio, setCodigoMunicipio] = useState('');
  const [nomeMunicipio, setNomeMunicipio] = useState('');
  const [loading, setLoading] = useState(false);
  const [openModalBuscaMunicipio, setOpenModalBuscaMunicipio] = useState(false);

  useEffect(() => {
    if (open) {
      // Definir data atual como padrão
      const hoje = new Date();
      const dataFormatada = hoje.toISOString().split('T')[0]; // YYYY-MM-DD
      setDataEncerramento(dataFormatada);
      setUf('');
      setCodigoMunicipio('');
      setNomeMunicipio('');
      setLoading(false);
      setOpenModalBuscaMunicipio(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!dataEncerramento || dataEncerramento.trim() === '') {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Por favor, informe a data de encerramento',
        })
      );
      return;
    }

    if (!uf || uf.length !== 2) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Por favor, selecione a UF',
        })
      );
      return;
    }

    if (!codigoMunicipio || codigoMunicipio.trim() === '') {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Por favor, informe o código do município',
        })
      );
      return;
    }

    // Validar formato do código do município (deve ser numérico, 7 dígitos)
    const codigoLimpo = codigoMunicipio.replace(/\D/g, '');
    if (codigoLimpo.length !== 7) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'O código do município deve ter 7 dígitos',
        })
      );
      return;
    }

    setLoading(true);
    try {
      if (onConfirm) {
        await onConfirm({
          data_encerramento: dataEncerramento,
          uf: uf.toUpperCase(),
          codigo_municipio: codigoLimpo,
        });
      }
      handleClose();
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: error.message || 'Erro ao processar encerramento',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setDataEncerramento('');
    setUf('');
    setCodigoMunicipio('');
    setNomeMunicipio('');
    setOpenModalBuscaMunicipio(false);
    onClose();
  };

  const handleSelectMunicipio = (municipio) => {
    setCodigoMunicipio(municipio.codigo);
    setNomeMunicipio(municipio.nome);
    // Se a UF não estiver preenchida, preencher com a UF do município
    if (!uf && municipio.uf) {
      setUf(municipio.uf);
    }
  };

  const isFormValid = () => {
    return (
      dataEncerramento &&
      dataEncerramento.trim() !== '' &&
      uf &&
      uf.length === 2 &&
      codigoMunicipio &&
      codigoMunicipio.replace(/\D/g, '').length === 7
    );
  };

  return (
    <Modal open={open} onClose={handleClose} title="Encerrar MDF-e">
      <Container>
        <div style={{ marginBottom: '15px', color: '#333', fontSize: '14px', fontWeight: 'normal' }}>
          Você está encerrando <strong style={{ color: '#333', fontWeight: 'bold' }}>{quantidadeMdfe}</strong> MDF-e(s). Informe os dados de encerramento:
        </div>
        
        <WrapperInput>
          <TextField
            label="Data de Encerramento"
            name="data_encerramento"
            type="date"
            value={dataEncerramento}
            onChange={(e) => setDataEncerramento(e.target.value)}
            fullWidth
            required
            InputLabelProps={{
              shrink: true,
              style: { color: '#666' },
            }}
            inputProps={{
              style: { color: '#333' },
            }}
          />
        </WrapperInput>

        <Row>
          <WrapperInput style={{ flex: 1, marginRight: '10px' }}>
            <TextField
              label="UF"
              name="uf"
              value={uf}
              onChange={(e) => {
                const value = e.target.value.toUpperCase().substring(0, 2);
                setUf(value);
              }}
              fullWidth
              required
              placeholder="Ex: SP"
              InputLabelProps={{
                style: { color: '#666' },
              }}
              inputProps={{
                maxLength: 2,
                style: { 
                  textTransform: 'uppercase',
                  color: '#333',
                },
              }}
            />
          </WrapperInput>

          <WrapperInput style={{ flex: 2 }}>
            <InputWithButton>
              <TextField
                label="Código do Município (IBGE)"
                name="codigo_municipio"
                value={codigoMunicipio}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '').substring(0, 7);
                  setCodigoMunicipio(value);
                  // Limpar nome do município se o código for alterado manualmente
                  if (value !== codigoMunicipio) {
                    setNomeMunicipio('');
                  }
                }}
                fullWidth
                required
                placeholder="Ex: 3550308"
                InputLabelProps={{
                  style: { color: '#666' },
                }}
                inputProps={{
                  maxLength: 7,
                  style: { color: '#333' },
                }}
              />
              <div style={{ 
                marginLeft: '10px',
                marginTop: '8px',
                display: 'flex',
                alignItems: 'center'
              }}>
                <Button
                  label="Consultar"
                  onClick={() => setOpenModalBuscaMunicipio(true)}
                  color="primary"
                  width="120px"
                  height="56px"
                />
              </div>
            </InputWithButton>
            {nomeMunicipio && (
              <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                Município: <strong>{nomeMunicipio}</strong>
              </div>
            )}
          </WrapperInput>
        </Row>

        <div style={{ fontSize: '12px', color: '#666', marginTop: '-10px', marginBottom: '15px' }}>
          O código do município deve ter 7 dígitos (código IBGE)
        </div>

        <WrapperButtons>
          <Button
            label="Cancelar"
            onClick={handleClose}
            color="secondary"
            margin="0 10px 0 0"
            disabled={loading}
          />
          <Button
            label={loading ? 'Processando...' : 'Confirmar Encerramento'}
            onClick={handleSubmit}
            color="primary"
            disabled={loading || !isFormValid()}
          />
        </WrapperButtons>
      </Container>

      <ModalBuscaMunicipio
        open={openModalBuscaMunicipio}
        onClose={() => setOpenModalBuscaMunicipio(false)}
        onSelect={handleSelectMunicipio}
        ufFiltro={uf}
      />
    </Modal>
  );
}

export default ModalEncerramentoMdfe;

